// extracted by mini-css-extract-plugin
export var cameraTeaserGrid = "CameraTeaser-module--cameraTeaserGrid--d0573";
export var mediaSliderControls = "CameraTeaser-module--mediaSliderControls--3ce92";
export var pager = "CameraTeaser-module--pager--ba842";
export var teaser = "CameraTeaser-module--teaser--6ff8a";
export var teaserContainer = "CameraTeaser-module--teaserContainer--5a02e";
export var wrapper = "CameraTeaser-module--wrapper--c5e7c";